import { render, staticRenderFns } from "./ImageViewDialog.vue?vue&type=template&id=6367470a&scoped=true&"
import script from "./ImageViewDialog.vue?vue&type=script&lang=js&"
export * from "./ImageViewDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewDialog.vue?vue&type=style&index=0&id=6367470a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6367470a",
  null
  
)

export default component.exports